import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstName',
    standalone: false
})
export class TidyFirstNamePipe implements PipeTransform {
  transform(name: string): string {
    return name?.trim().split(/\s+/)[0] ?? '';
  }
}
